/**
 * Generated from ch7_p06.fla
 */
export function ch7_p06(this: Ich7_p06) {
	const lines = this.lines;
	if (!lines[0] && lines.elementFactory) {
		lines[0] = lines.elementFactory(0,undefined);
	}
	if (lines[0]) {
		ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3.call(lines[0] as Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3);
		lines[0].x = 1189;
		lines[0].y = 197.25;
		lines[0].width = 186.00;
		lines[0].height = 11.50;
		lines[0].alpha = 1;
		if (lines[0].onLayout) lines[0].onLayout();
	}
	if (!lines[1] && lines.elementFactory) {
		lines[1] = lines.elementFactory(1,undefined);
	}
	if (lines[1]) {
		ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2.call(lines[1] as Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2);
		lines[1].x = 1149.25;
		lines[1].y = 124.5;
		lines[1].width = 145.50;
		lines[1].height = 83.00;
		lines[1].alpha = 1;
		if (lines[1].onLayout) lines[1].onLayout();
	}
	if (!lines[2] && lines.elementFactory) {
		lines[2] = lines.elementFactory(2,undefined);
	}
	if (lines[2]) {
		ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1.call(lines[2] as Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1);
		lines[2].x = 1097.25;
		lines[2].y = 100.5;
		lines[2].width = 73.50;
		lines[2].height = 93.00;
		lines[2].alpha = 1;
		if (lines[2].onLayout) lines[2].onLayout();
	}
	const bg = this.bg;
	ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_holly.call(this.holly);
	holly.x = 755.25;
	holly.y = 768;
	holly.width = 777.50;
	holly.height = 764.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 343.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_bg(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p06_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_holly(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p06_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeRframe(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeLframe(this: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich7_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p06Sprite extends Ich7_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p06Text extends Ich7_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p06Polygon extends Array<number> {
}
interface Ich7_p06 {
	readonly lines: Ich7_p06Array<Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3|Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2|Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1>;
	readonly bg: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_bg;
	readonly holly: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_holly;
	readonly frameRight: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeRframe;
	readonly frameLeft: Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeLframe;
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_bg extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_holly extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines3 extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines2 extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_lines1 extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeRframe extends Ich7_p06Sprite {
}
interface Ich7_p06_hh_ch7_72dpi_p06psdAssetchp7_p06_wcframeLframe extends Ich7_p06Sprite {
}
